module.exports = __webpack_public_path__ + "img/دفترچه-تلفن--چسبی.826f55e5.png";